"use strict";

exports.__esModule = true;
exports.UnitInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Catalogs = require("../../../Catalogs");
var _excluded = ["value", "units", "onChange"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// Symbol which lives in the input group
// Note: these styles are direct from blueprint to work around
// a limitation of input groups.
var UnitSymbol = _styledComponents["default"].span.withConfig({
  displayName: "UnitInput__UnitSymbol",
  componentId: "sc-1pqn9yv-0"
})(["user-select:none;min-width:24px;min-height:24px;margin:3px;padding:0 7px;z-index:4;display:flex;justify-content:center;align-items:center;"]);

/**
 * Input for values in the specified units.
 * Used in lib-ui-knowledge-base
 */
var UnitInput = exports.UnitInput = /*#__PURE__*/function (_Component) {
  function UnitInput() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleChange = function (e) {
      var onChange = _this.props.onChange;
      var value = e.target.value;
      onChange(value);
    };
    return _this;
  }
  _inheritsLoose(UnitInput, _Component);
  var _proto = UnitInput.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      value = _this$props.value,
      units = _this$props.units,
      _onChange = _this$props.onChange,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var type = "text";
    var rightElement;
    if (units) {
      var definition = (0, _Catalogs.getUnitDefinition)(units);
      type = "number";
      rightElement = /*#__PURE__*/_react["default"].createElement(UnitSymbol, null, definition.symbol);
    }
    return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
      type: type,
      rightElement: rightElement,
      value: value === undefined ? "" : value,
      onChange: this.handleChange
    }, extra));
  };
  return UnitInput;
}(_react.Component);